"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _globals = _interopRequireDefault(require("./globals"));

var _clientErrorLogger = _interopRequireDefault(require("./clientErrorLogger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var _exports = {};

var SessionManager = /*#__PURE__*/function () {
  function SessionManager(session, dispatcher) {
    _classCallCheck(this, SessionManager);

    if (!session || !dispatcher) {
      throw new Error("SessionManager started with no session or dispatcher.");
    }

    this.maxInactivitySeconds = session.inactivityThreshold ? session.inactivityThreshold : 600;
    this.inactivityTimeRemaining = this.maxInactivitySeconds;
    this.warningThreshold = session.expirationWarningSeconds ? session.expirationWarningSeconds : 60;
    this.serverTimeRemaining = session.serverTimeRemaining;
    this.dispatcher = dispatcher;
    this.session = session;

    _clientErrorLogger.default.setSessionId(session.id);
  }

  _createClass(SessionManager, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        var tickInterval = 1000;
        this.timer = setInterval(function () {
          this.inactivityTimeRemaining -= 1;
          this.serverTimeRemaining -= 1;
          this.checkServerExpiration();
          this.checkInactivity();
        }.bind(this), tickInterval);
        this.bindActivityEvents();
        this.started = true;
      }

      this.restart();
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.timer);
    }
  }, {
    key: "addListenerMulti",
    value: function addListenerMulti(el, eventNames, fn) {
      var events = eventNames.split(" ");

      for (var i = 0, iLen = events.length; i < iLen; i++) {
        if (el.addEventListener) {
          el.addEventListener(events[i], fn, true);
        } else {
          el.attachEvent("on" + events[i], fn);
        }
      }
    }
  }, {
    key: "bindActivityEvents",
    value: function bindActivityEvents() {
      var bindingEl = window ? window : document;

      if (bindingEl) {
        this.addListenerMulti(bindingEl, "touchstart touchmove touchend keydown keyup click", this.restart.bind(this));
      }
    }
  }, {
    key: "restart",
    value: function restart() {
      this.inactivityTimeRemaining = this.maxInactivitySeconds;

      if (this.serverTimeRemaining < this.inactivityTimeRemaining) {
        this.dispatcher.emit("LOAD_SESSION_DATA", {
          forceRefresh: true
        });
      }
    }
  }, {
    key: "update",
    value: function update(session) {
      this.session = session;
      this.serverTimeRemaining = session.serverTimeRemaining;
      this.maxInactivitySeconds = session.inactivityThreshold ? session.inactivityThreshold : 600;
      this.warningThreshold = session.expirationWarningSeconds ? session.expirationWarningSeconds : 60;

      _clientErrorLogger.default.setSessionId(session.id);
    } // checks the server-side session tick in seconds

  }, {
    key: "checkServerExpiration",
    value: function checkServerExpiration() {
      var secsLeft = this.serverTimeRemaining;

      if (secsLeft <= 0) {
        this.dispatcher.emit("SESSION_EXPIRED");
        this.stop();
      } else if (secsLeft < this.warningThreshold && secsLeft < this.inactivityTimeRemaining) {
        // send a request to extend server-side session
        this.dispatcher.emit("LOAD_SESSION_DATA", {
          forceRefresh: true
        });
      }
    } // check on the client inactivity counter

  }, {
    key: "checkInactivity",
    value: function checkInactivity() {
      if (this.inactivityTimeRemaining <= 0) {
        this.dispatcher.emit("SESSION_EXPIRED");
        this.stop();
      } else if (this.inactivityTimeRemaining <= this.warningThreshold) {
        this.dispatcher.emit("SESSION_EXPIRING", {
          remainingTime: this.inactivityTimeRemaining
        });
      } else {
        this.dispatcher.emit("HIDE_SESSION_EXPIRING_MODAL");
      }
    }
  }, {
    key: "getLoginPath",
    value: function getLoginPath() {
      return this.session.loginPath;
    }
  }, {
    key: "isStarted",
    value: function isStarted() {
      return this.started;
    }
  }]);

  return SessionManager;
}();

_exports.getLoginPath = function () {
  if (_globals.default.sessionManager) {
    return _globals.default.sessionManager.getLoginPath();
  }

  return "/login";
};

_exports.getInstance = function (session, dispatcher) {
  if (_globals.default.sessionManager) {
    return _globals.default.sessionManager;
  }

  _globals.default.sessionManager = new SessionManager(session, dispatcher);
  return _globals.default.sessionManager;
};

_exports.SessionManager = SessionManager;
var _default = _exports;
exports.default = _default;